<template>
  <div>
    <b-form-group>
      <b-form-select
        v-bind:value="value"
        v-on:input="$emit('input', $event);"
        :options="data"
        size="md"
        :required="required"
        :select-size="select_size"
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "Select",
  data() {
    return {};
  },
  props: {
    data: { type: Array, required: true, default: () => [] },
    select_size: { type: Number, required: false, default: 1 },
    value: { required: false, default: null },
    required: { required: false, default: false }
  },
  methods: {
  },
};
</script>
